<template>
  <div class="subsection" v-if="selectedVendorProject">
    <div
      class="table-data__tool clearfix"
      style="
      background: rgb(214, 213, 213);
    border: 1px solid #e2e2e2;
    padding: 5px 10px;"
    >
      <div class="float-right">
        <button class="sideB bLightBlue d-inline-block mr-3" @click="createItem('IN')" v-if="hasPermission('create samplestock')">
          <i class="zmdi zmdi-plus"></i> Stock In
        </button>
        <button class="sideB bLightBlue d-inline-block" @click="createItem('OUT')" v-if="hasPermission('create samplestock')">
          <i class="zmdi zmdi-minus"></i> Stock Out
        </button>
      </div>
    </div>
    <DataTable
      ref="datatable"
      :secondary="true"
      :settings="datatable.settings"
      :dataColumns="datatable.columns"
      :dataFeed="datatable.dataFeed"
      :dataHandle="datatable.handle"
      :dataTableHeight="datatable.height"
      :defaultSortBy="datatable.sortBy"
      :defaultOrderBy="datatable.orderBy"
      :customViewItem="viewItem"
      :customEditItem="editItem"
      :allowView="allowView"
      :allowEdit="allowEdit"
      :allowDelete="allowDelete"
      :hasContextMenu="hasContextMenu"
    >
      <template slot="menuButtons" slot-scope="props">
        <template v-if="props.item && props.item.data">
          <li @click="$refs.datatable.viewItem($event, props.item.data)" v-if="allowView(props.item.data)">View</li>
          <li @click="$refs.datatable.editItem($event, props.item.data)" v-if="allowEdit(props.item.data)">Edit</li>
          <li @click="$refs.datatable.confirmDelete($event, props.item.data)" v-if="allowDelete(props.item.data)">Delete</li>
        </template>
      </template> 
    </DataTable>
    <StockHistoryEdit
      :stockType="stockType"
      :formMode="formMode"
      :formShow="isEditing"
      :selectedVendorProject="selectedVendorProject"
      :selectedItem="selectedItem"
      @closeEdit="closeEdit"
      @reload="reload"
    />
  </div>
</template>
<script>
import StockHistoryEdit from "./StockHistoryEdit";

export default {
  name: "VendorProjectHistory",
  components: {
    StockHistoryEdit
  },
  props: {
    selectedVendorProject: Object
  },
  data() {
    return {
      selectedItemContact: [],
      datatable: {
        settings: {
          sectionName: "samplestock",
          webService: this.$root.WebService.samplestock
        },
        dataFeed: null,
        handle: null,
        columns: [
          { key: 'created_at', title: 'Stock Date', type: 'datepicker', width: '10%', value: { from: null, to: null }, datafilter: this.$options.filters.dateFormat },
          { key: 'customer', title: "Customer", type: "input", width: "15%", value: null },
          { key: 'type', title: "Type", type: "input", width: "5%", value: null },
          { key: 'quantity', title: "Quantity", type: "input", width: "5%", value: null },
          { key: 'attachmentCount', title: "Attachments", type: "input", width: "5%", value: null },
          { key: 'journal', title: "Journal", type: "input", width: "60%", value: null },
        ],
        sortBy: null,
        orderBy: "desc",
        height: "60vh",
      },
      datas: [],
      filteredDatas: [],
      isEditing: false,
      selectedItem: null,
      formMode: null,
      stockType: null,
    };
  },
  mounted() {
    this.datatable.handle = (res) => this.datas = res.data.data
    this.datatable.dataFeed = {
      method: 'get',
      url: this.WebService.samplestock + '/' + this.selectedVendorProject.vendorproject.id + '/history'
    }
  },
  methods: {
    viewItem(item) {
      this.formMode = 'view'
      this.isEditing = true
      this.selectedItem = item
    },
    editItem(item) {
      this.formMode = 'edit'
      this.isEditing = true
      this.selectedItem = item
    },
    createItem(type) {
      this.formMode = 'create'
      this.isEditing = true
      this.stockType = type
    },
    closeEdit() {
      this.formMode = null
      this.isEditing = false
      this.selectedItem = null
      this.stockType = null
    },
    allowView(item) {
      return this.hasPermission('read samplestock')
    },
    allowEdit(item) {
      return this.hasPermission('update samplestock')
    },
    allowDelete(item) {
      return this.hasPermission('delete samplestock')
    },
    hasContextMenu(item) {
      return this.allowView(item) || this.allowEdit(item) || this.allowDelete(item)
    },
    reload() {
      this.$refs.datatable.reload()
      this.$emit('reloadParent', null, this.selectedVendorProject)
    }
  }
};
</script>